import { MdOutlineArrowBackIos } from "react-icons/md";
import { FaBell } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import HeaderUserDropdown from "./user-dropdown.component";
import { useState, useEffect } from "react";
import { classNames } from "utils/helper/helper";
import styled from "styled-components";

const Header = styled.div`
  display: flex;
  align-items: center;
  padding: 10px;
  color: white;
`;

const UserDashboardnav: React.FC<{ title?: string; id?: string }> = ({
  title,
  id,
}) => {
  const [scrolled, setScrolled] = useState<boolean>(false);
  const navigate = useNavigate();

  function displayTitle() {
    if (title) {
      if (id) {
        return (
          <Link to={`/service-provider/${id}`} className="relative">
            <Header>
              {/* <ProfileImage src={profileImage} alt="Profile" /> */}
              <div>{title}</div>
            </Header>
            {/* <p className="text-[10px] font-medium flex justify-center"></p> */}
          </Link>
        );
      } else {
        return <p className="text-[10px] font-medium flex justify-center"></p>;
      }
    }
    return <p></p>;
  }

  const handleGoBack = () => {
    if (window.history.length > 1) {
      navigate(-1); // Go back to the previous page
    } else {
      navigate("/services"); // Navigate to the dashboard
    }
  };
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY >= 100) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return (
    <header
      className={classNames(
        "top-0 z-20 w-full h-[15vh]",
        scrolled
          ? "fixed bg-white/20 dark:bg-black/20 backdrop-blur transition-colors"
          : ""
      )}
    >
      <nav className="flex justify-between px-6 py-6 xl:px-24 ">
        <span
          onClick={handleGoBack}
          className="bg-[#D64B03] w-10 h-10 rounded-full flex justify-center items-center"
        >
          <MdOutlineArrowBackIos className="w-6 h-6" />
        </span>
        {displayTitle()}
        <div className="flex items-center gap-4">
          <Link to={"/dashboard/notifications"} className="relative">
            <FaBell className="w-4 h-4" />
            <div className="w-2 h-2 border-2 border-white rounded-full bg-[#E50000] absolute -top-0.5 -right-[0.5px]"></div>
          </Link>
          <HeaderUserDropdown />
        </div>
      </nav>
    </header>
  );
};
export default UserDashboardnav;
